// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"75defa33","1395":"75defa33","3761":"75defa33","5309":"75defa33","6761":"75defa33","8190":"75defa33","9591":"75defa33"}[chunkId] + ".chunk.css";
};